import { render, staticRenderFns } from "./TahsilatComponent.vue?vue&type=template&id=e9df062c&"
import script from "./TahsilatComponent.vue?vue&type=script&lang=js&"
export * from "./TahsilatComponent.vue?vue&type=script&lang=js&"
import style0 from "./TahsilatComponent.vue?vue&type=style&index=0&id=e9df062c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports